import { mainColor, UNIT } from '../../constants';

export const styles = () => ({
  produits: {
    fontSize: UNIT * 0.9375,
    minWidth: UNIT * 9,
    maxWidth: UNIT * 20,
    padding: UNIT * 1.0625,
    wordBreak: 'break-all'
  },
  heading: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight,
  },
  table: {
    minWidth: 700
  },
  svg: { padding: UNIT * 0.625 },
  disabledSvg: { color: '#858383' },
  headingTab: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight
  }
});
